export const RESOURCE_TYPE = {
  RESOURCE_LIBRARY: 5, //数据集导入
};
